const ROOT = 'StepThree/publicationConfirmation/printConsume';

export const FETCH_PRINT_CONSUME_REQUEST = `${ROOT}/FETCH_PRINT_CONSUME_REQUEST`;
export const FETCH_PRINT_CONSUME_SUCCESS = `${ROOT}/FETCH_PRINT_CONSUME_SUCCESS`;
export const FETCH_PRINT_CONSUME_FAILURE = `${ROOT}/FETCH_PRINT_CONSUME_FAILURE`;
